const option = {
    baseUrl: 'http://api.nbiotemtc.com:10221',
    // baseUrl: 'http://10.159.15.20:10221',
    sessionOverdue: 20103,
    successCode: 10001,
    mapStyle: 'amap://styles/a90fdbf09e9de5d7e77fc35f3be2829c',
    amapKey: '0356ab7bd4a747f72b8df72ec01cf814',
    authPages: [
        {title: '首页', key: '/home', icon: 'home'},
        {title: '终端', key: 'terminal', icon: 'home',
            children: [
                {title: '设备详情', key: '/machine', icon: 'home'},
                // {title: '井盖管理', key: '/home', icon: 'home'},
                // {title: '智能锁管理', key: '/home', icon: 'home'},
                // {title: '烟感管理', key: '/home', icon: 'home'},
                // {title: '门磁管理', key: '/home', icon: 'home'},
                // {title: '三保管理', key: '/home', icon: 'home'},
            ]
        },
        {title: '工单', key: 'order', icon: 'home',
            children: [
                {title: '工单管理', key: '/worker', icon: 'home'},
                {title: '工单统计', key: '/workOrder', icon: 'home'},
            ]
        },
        {title: '日志', key: 'log', icon: 'home',
            children: [
                {title: '日志', key: '/logPush', icon: 'home'},
            ]
        },
        {title: '统计', key: 'statistical', icon: 'home',
            children: [
                {title: '告警统计', key: '/AlarmStatistics', icon: 'home'},
                {title: '工作统计', key: '/wSituation', icon: 'home'},
            ]
        },
        {title: '设置', key: 'system', icon: 'home',
            children: [
                {title: '人员管理', key: '/logStatistics', icon: 'home'},
                {title: '设备管理', key: '/machineStatistics', icon: 'home'},
                {title: '设备添加', key: '/addMachine', icon: 'home'},
            ]
        },
    ],
    workBodyArr: {
        '1': {
            label: '车辆', icon: 'car', stateOption: {
                '1': {title: '正常', icon: 'http://120.27.2.82:11111/sanitationCloud3/car_succ.png', color: '#35b400'},
                '-1': {title: '离线', icon: 'http://120.27.2.82:11111/sanitationCloud3/car_def.png', color: '#888888'},
                '3': {title: '驻车', icon: 'http://120.27.2.82:11111/sanitationCloud3/car_pin.png', color: '#3181ff'},
                '5': {title: '告警', icon: 'http://120.27.2.82:11111/sanitationCloud3/car_err.png', color: '#fbdb19'},
            }
        },
        '2': {
            label: '人员', icon: 'crew', stateOption: {
                '1': {title: '正常', icon: 'http://120.27.2.82:11111/sanitationCloud3/person_succ.png', color: '#35b400'},
                '-1': {title: '离线', icon: 'http://120.27.2.82:11111/sanitationCloud3/person_def.png', color: '#888888'},
                '3': {title: '驻车', icon: 'http://120.27.2.82:11111/sanitationCloud3/person_pin.png', color: '#3181ff'},
                '5': {title: '告警', icon: 'http://120.27.2.82:11111/sanitationCloud3/person_err.png', color: '#fbdb19'},
            }
        },
        '3': {label: '院落', icon: 'yard', stateOption: 'http://120.27.2.82:11111/sanitationCloud3/courtyard.png'},
    },
    workBodyStatusConfig: {
        '1': {
            label: '车辆', icon: 'car', baseUrl: 'http://120.27.2.82:11111/sanitationCloud3/',
            stateOption: {
                '1': {title: '正常', icon: '_work', color: '#35b400'},
                '-1': {title: '离线', icon: '_offline', color: '#888888'},
                '3': {title: '驻车', icon: '_stay', color: '#3181ff'},
                '5': {title: '告警', icon: '_alarm', color: '#fbdb19'},
            }
        },
        '2': {
            label: '人员', icon: 'car', baseUrl: 'http://120.27.2.82:11111/sanitationCloud3/',
            stateOption: {
                '1': {title: '正常', icon: '_work', color: '#35b400'},
                '-1': {title: '离线', icon: '_offline', color: '#888888'},
                '3': {title: '停留', icon: '_stay', color: '#3181ff'},
                '5': {title: '告警', icon: '_alarm', color: '#fbdb19'},
            }
        },
        '3': {
            label: '院落', icon: 'car', baseUrl: 'http://120.27.2.82:11111/sanitationCloud3/',
        },
    }
}

export default option;
